import React, { Component, createRef } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Desktop, Mobile }  from '../../../media'
import UserMenuItems from './UserMenuItems'
import employeeService from '../../../services/Employee.service'
import Navigation from '../navigation'


import DefaultProfileImage from '../../../images/profile.png'
import HamburgerMenuImage from '../../../images/hamburger.png'
// import { Wrapper } from 'react-aria-menubutton'


const UserInfoContainer = styled.div`
  display: inline-block;
  margin-top: 8px;
  float: right;
`

const UserProfileImage = styled.img`
  width: 34px;
  height: 34px;
  float: left;
`

const ChevronPrimaryImage = styled.img`
  width: 15px;
  height: 8.9px;
  margin-left: 5px;
  cursor: pointer;
`

const UserName = styled.h2`
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 8px;
  font-family: Lato-Regular;
  font-size: 14px;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 22px;
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
`

const Details = styled.details`
  height: 30px;
  float: right;
  position: relative;
`

const HamburgerMenuIcon = styled.img`
  width: 30px;
  height: 15px;
  display: inline-block;
`

const MenuBackground = styled.div`
display: block;
width: 100%;
height: auto;
background-color: white;
box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
border-top: none;
`

class UserInfoMenu extends Component {

  detailsRef = createRef();
  summaryRef = createRef();

  constructor(props) {
    super(props);
  }

  onUserMenuSelection = (value) => {
    this.props.onUserMenuSelection(value, this.summaryRef.current);
    this.closeDetails();
  }

  onMobileDetailsToggle = () => {
    this.focusSummary();
  }

  onNavigationLinkClicked = () => {
    this.closeDetails();
  }

  onBlur = (e) => {
    const currentTarget = e.currentTarget;

    requestAnimationFrame(() => {
      // Check if the new focused element is a child of the original container
      if (!currentTarget.contains(document.activeElement)) {
        this.closeDetails();
      }
    });
  }

  closeDetails = () => {
    if (this.detailsRef !== undefined && this.detailsRef.current) {
      this.detailsRef.current.removeAttribute('open');
    }
  }

  focusSummary = () => {
    this.summaryRef.current.focus();
  }

  render() {
    const {languageName} = this.props
    return (
      <UserInfoContainer>
        <Details onToggle={this.onMobileDetailsToggle} id="menu-details" ref={this.detailsRef} onBlur={this.onBlur}>
          <summary ref={this.summaryRef} style={{padding: '2px 6px', border: 'none', cursor: 'pointer', listStyle: 'none'}}>
            <UserProfileImage src={DefaultProfileImage} alt="User Menu"/>
            <Desktop>
              <UserName className="username">{`${this.props.employee.first_name} ${this.props.employee.last_name} (${this.props.employee.employee_external_id}) ${languageName}`}</UserName>  
            </Desktop>
            <Mobile>
              <UserName className="username">{`${this.props.employee.first_name} ${this.props.employee.last_name}`}</UserName>
            </Mobile>
            <HamburgerMenuIcon src={HamburgerMenuImage} />
          </summary>
          <div>
            <Mobile>
              <Navigation callbackParent={this.onNavigationLinkClicked} />
            </Mobile>
            <MenuBackground>
              <UserMenuItems onUserMenuSelection={this.onUserMenuSelection} exitFunc={this.onNavigationLinkClicked}/>
            </MenuBackground>
          </div>
        </Details>
      </UserInfoContainer>
    )
  }
}

const mapState = state => ({
  employee: state.employee,
  languageName: employeeService.getLanguageByCode(state.configuration.languages, state.employee.language).name
})

export default connect(mapState)(withTranslation('translations')(UserInfoMenu))
